<template>
  <div>
    <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
    <p v-if="!isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
    </p>
    <p v-if="isMobileAds" class="has-text-centered">&nbsp;</p>
    <p v-if="isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
    </p>
    <industry-carousel heading="Top industries" v-on:industry-carousel-loaded="industryCarouselLoaded"></industry-carousel>
<!--    <leader-board></leader-board>-->
    <p v-if="!isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="thirdAd"></ad>
    </p>
    <p v-if="isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
    </p>
<!--    <leader-board-mobile></leader-board-mobile>-->
    <h4 class="title has-text-weight-bold">All industries</h4>
    <p v-if="fetching_all_industries" class="has-text-centered spinner"><img src="/static/img/spinner.svg" alt="Fetching all industries" /></p>
    <div v-if="!fetching_all_industries" class="columns is-multiline industries-columns">
      <div v-for="industry in industries" class="column is-one-third-tablet is-one-quarter-desktop">
        <article class="media">
          <figure class="media-left">
            <p class="image is-32x32">
              <img :src="`/static/img/industries/svg/${industry.slug}.svg`" alt="`${industry.slug}`" />
            </p>
          </figure>
          <div class="media-content">
            <p><a :href="`/industries/${industry.slug}`" v-html="industry.name"></a></p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import IndustryCarousel from '@/components/IndustryCarousel'
  import LeaderBoard from '@/components/Leaderboard'
  import LeaderBoardMobile from '@/components/LeaderBoardMobile'
  import adsConfig from '@/mixins/ad_config'
  import Ad from '@/components/ProgrammaticAds'

  export default {
    name: 'IndustryIndex',
    components: {
      IndustryCarousel,
      LeaderBoard,
      LeaderBoardMobile,
      Ad
    },
    mixins: [adsConfig],
    metaInfo () {
      return {
        title: 'Industries | Customer Service & Company Ratings | hellopeter.com',
        bodyAttrs: {
          class: 'industries'
        },
        meta: [
          { name: 'description', content: 'Use Hellopeter to find and compare the best industries in South Africa. From Cape Town to Johannesburg, our reviews help you find the most trusted businesses online.' }
        ],
        links: [
          { rel: 'canonical', href: `${window.location.protocol}//${window.location.host}${this.$route.path}` }
        ]
      }
    },
    created () {
      this.getAllIndustries()
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Industries',
        brandName: '',
        industryName: ''
      })
      this.loadAds()
    },
    data () {
      return {
        industry_carousel_loaded: false,
        fetching_all_industries: false,
        industries: []
      }
    },
    methods: {
      industryCarouselLoaded () {
        this.industry_carousel_loaded = true
      },
      getAllIndustries () {
        this.fetching_all_industries = true
        axios.get('/consumer/industries/list')
          .then(({data}) => {
            this.fetching_all_industries = false
            let temp = data
            let removeAllIndustry = temp.map(industry => industry.name).indexOf('All')
            temp.splice(removeAllIndustry, 1)
            // let removeBusinessServicesIndustry = temp.map(industry => industry.name).indexOf('Business Services')
            // temp.splice(removeBusinessServicesIndustry, 1)
            this.industries = temp
          })
          .catch(() => {
            this.fetching_all_industries = false
            flash('There was an error retreiving all of the Industries', 'is-warning')
          })
      }
    },
    computed: {
      carouselAndIndustries () {
        const industryLength = this.industries.length
        const industryLoaded = parseInt(this.industry_carousel_loaded)
        return `${industryLength},${industryLoaded}`
      }
    },
    watch: {
      carouselAndIndustries () {
        window.prerenderReady = true
      }
    }
  }
</script>
<style scoped>
  h4 {
    max-width: 1100px;
    font-size: 1.3rem;
    color: #58595B;
    margin: 2rem auto;
  }

  .industries-columns {
    max-width: 1100px;
    color: #58595B;
    margin: 2rem auto;
  }

  .industries-columns .media-content a, .industries-columns .media-content a:hover, .industries-columns .media-content a:visited {
    text-decoration: none;
    color: #58595B;
    font-size: 0.9rem;
    font-weight: 700;
  }

  .media-left > .image {
    /*width: 30px;*/
  }

  @media screen and (max-width: 1024px) {
    h4 {
      margin-left: 2rem;
    }

    .industries-columns {
      max-width: 100%;
      margin: 2rem 0 3rem 1.2rem;
    }

    .industries-columns .media-content a {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 767px) {
    h4 {
      margin-left: 1.5rem;
    }

    .industries-columns .media-content a {
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/industries/IndustryIndex.vue